import * as React from "react";
import {cx} from "emotion";

import "./list-view.scss";

import {cs}    from "@Common/react/chain-services";
import {keyed} from "@Common/react/keyed";
import {Radio} from "@Common/ui-components/heavy/common/design2/radio/radio";

export const ListView = ({items}) => cs(
    () => (
        <div className="list-view list-view-2sj">
            {items?.map(({key, selected, isDefault, label, img, onClick}) => cs(
                keyed(key),
                () => (() => {
                    return (
                        <div {...{
                            className: cx("item", {selected}),
                            onClick,
                        }}>
                            <div className="indicator">
                                {Radio({
                                    selected,
                                })}
                            </div>

                            <div className="text">
                                {label}
                            </div>

                            {isDefault && (
                                <div className="default">
                                    <div className="default">
                                        Default
                                    </div>
                                </div>
                            )}

                            <div {...{
                                className: cx("thumbnail", {placeholder: !img}),
                            }}>
                                {!img && (
                                    <i className="fa fa-picture-o"/>
                                )}
                                <img src={img}/>
                            </div>
                        </div>
                    );
                })(),
            ))}
        </div>
    ),
);
